<div class="ph-parent">
    @if (demo) {
        <!-- ═══════════════════════════ HERO ═══════════════════════════ -->
        <section class="ph-hero">
            <div class="ph-hero__bg">
                <div class="ph-blob ph-blob--1"></div>
                <div class="ph-blob ph-blob--2"></div>
                <div class="ph-blob ph-blob--3"></div>
                <div class="ph-grid-lines"></div>
            </div>
            <div class="ph-hero__content">
                <div class="ph-badge">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                        />
                    </svg>
                    {{ 'web.livescore_platform' | translate }}
                </div>
                <h1 class="ph-hero__title">
                    {{ 'web.unlock' | translate }} <span class="ph-accent">{{ 'web.premium' | translate }} </span
                    ><br class="ph-hero__br" />
                    {{ 'web.statistics' | translate }}
                </h1>
                <p class="ph-hero__subtitle">
                    {{ 'web.real_time_analytics' | translate }}
                </p>
                <div class="ph-hero__stats">
                    <div class="ph-stat">
                        <span class="ph-stat__num">40+</span>
                        <span class="ph-stat__label">{{ 'web.about_sport' | translate }} </span>
                    </div>
                    <div class="ph-stat__divider"></div>
                    <div class="ph-stat">
                        <span class="ph-stat__num">10000+</span>
                        <span class="ph-stat__label">{{ 'web.match_events' | translate }}</span>
                    </div>
                    <div class="ph-stat__divider"></div>
                    <div class="ph-stat">
                        <span class="ph-stat__num">{{ 'web.advertisement' | translate }}</span>
                        <span class="ph-stat__label">{{ 'web.no_ads' | translate }}</span>
                    </div>
                    <div class="ph-stat__divider"></div>
                    <div class="ph-stat">
                        <span class="ph-stat__num">API</span>
                        <span class="ph-stat__label">{{ 'web.full_access' | translate }}</span>
                    </div>
                </div>
                <a href="/page/see/pricing#ph-pricing-cards" class="ph-scroll-btn">
                    <span>{{ 'web.buy_package' | translate }}</span>
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                    >
                        <path d="M12 5v14M5 12l7 7 7-7" />
                    </svg>
                </a>
            </div>
            <div class="ph-hero__scroll-indicator">
                <div class="ph-scroll-mouse">
                    <div class="ph-scroll-mouse__wheel"></div>
                </div>
            </div>
        </section>

        <!-- ═══════════════════════════ FEATURES ═══════════════════════════ -->
        <section class="ph-features">
            <div class="ph-features__inner">
                <div class="ph-section-header">
                    <h2 class="ph-section-title">{{ 'web.everything_you_need' | translate }}</h2>
                    <p class="ph-section-subtitle">{{ 'web.everything_you_need' | translate }}</p>
                </div>
                <div class="ph-features__grid">
                    <div class="ph-feat" style="--fi: 0">
                        <div class="ph-feat__icon ph-feat__icon--yellow">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <circle cx="12" cy="12" r="10" />
                                <path d="M12 6v6l4 2" />
                            </svg>
                        </div>
                        <h3 class="ph-feat__title">{{ 'web.page_livescore' | translate }}</h3>
                        <p class="ph-feat__desc">{{ 'web.pricing-promo1' | translate }}</p>
                    </div>
                    <div class="ph-feat" style="--fi: 1">
                        <div class="ph-feat__icon ph-feat__icon--green">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <path d="M18 20V10M12 20V4M6 20v-6" />
                            </svg>
                        </div>
                        <h3 class="ph-feat__title">{{ 'web.pricing-promo2' | translate }}</h3>
                        <p class="ph-feat__desc">{{ 'web.pricing-promo3' | translate }}</p>
                    </div>
                    <div class="ph-feat" style="--fi: 2">
                        <div class="ph-feat__icon ph-feat__icon--blue">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <rect x="3" y="3" width="18" height="18" rx="2" />
                                <path d="M9 9h6M9 12h6M9 15h4" />
                            </svg>
                        </div>
                        <h3 class="ph-feat__title">{{ 'web.betting' | translate }}</h3>
                        <p class="ph-feat__desc">
                            {{ 'web.pricing-promo5' | translate }}
                        </p>
                    </div>
                    <div class="ph-feat" style="--fi: 3">
                        <div class="ph-feat__icon ph-feat__icon--orange">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <circle cx="12" cy="12" r="3" />
                                <path
                                    d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83"
                                />
                            </svg>
                        </div>
                        <h3 class="ph-feat__title">{{ 'web.sport_tracker' | translate }}</h3>
                        <p class="ph-feat__desc">{{ 'web.pricing-promo4' | translate }}</p>
                    </div>
                    <div class="ph-feat" style="--fi: 4">
                        <div class="ph-feat__icon ph-feat__icon--red">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                            </svg>
                        </div>
                        <h3 class="ph-feat__title">{{ 'web.american_sports_permission' | translate }}</h3>
                        <p class="ph-feat__desc">NFL, NBA, NHL &amp; MLB with</p>
                    </div>
                    <div class="ph-feat" style="--fi: 5">
                        <div class="ph-feat__icon ph-feat__icon--purple">
                            <svg
                                width="22"
                                height="22"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2"
                            >
                                <path
                                    d="M15 10l4.553-2.069A1 1 0 0121 8.87V15.13a1 1 0 01-1.447.9L15 14M3 8h12v9a1 1 0 01-1 1H4a1 1 0 01-1-1V8z"
                                />
                            </svg>
                        </div>
                        <h3 class="ph-feat__title">{{ 'web.stream_permission' | translate }}</h3>
                        <p class="ph-feat__desc">{{ 'web.stream_text_2' | translate }}</p>
                    </div>
                </div>
            </div>
        </section>
    }

    <!-- ═══════════════════════════ PRICING SECTION ═══════════════════════════ -->
    <section id="ph-pricing-cards" class="ph-pricing">
        @if (demo) {
            <div class="ph-section-header ph-section-header--center">
                <h2 class="ph-section-title">{{ 'web.choose_your_plan' | translate }}</h2>
                <p class="ph-section-subtitle">{{ 'web.no_hidden_fees' | translate }}</p>
            </div>
        }

        <!-- ── Billing Toggle ── -->
        <div class="ph-toggle-wrap">
            <span class="ph-toggle-label" [class.ph-toggle-label--on]="!annualMode">{{
                'web.monthly' | translate
            }}</span>
            <label class="ph-switch" for="switch8" aria-label="Toggle billing period">
                <input
                    #stickyVal4
                    (change)="onAnnualChange(stickyVal4.checked)"
                    [checked]="annualMode"
                    id="switch8"
                    type="checkbox"
                    data-cy="switch8"
                />
                <span class="ph-switch__track">
                    <span class="ph-switch__thumb"></span>
                </span>
            </label>
            <span class="ph-toggle-label" [class.ph-toggle-label--on]="annualMode">
                {{ 'web.annual' | translate }}
                <span class="ph-save-tag">{{ 'web.discount' | translate }} 50%</span>
            </span>
        </div>

        <!-- ── Cards ── -->
        <div class="ph-cards">
            @for (product of products; track $index) {
                <div
                    class="ph-card"
                    [class.ph-card--active]="isValid(product.permission.id)"
                    [class.ph-card--expired]="expired(product.permission.id)"
                    [class.ph-card--featured]="isAll(product.permission.permission)"
                    [style.--ci]="$index"
                >
                    @if (isAll(product.permission.permission)) {
                        <div class="ph-card__popular">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                                <path
                                    d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                                />
                            </svg>
                            Most Popular
                        </div>
                    }

                    <div class="ph-card__body">
                        <div class="ph-card__img-wrap">
                            <img
                                [attr.src]="'/img/packages/' + getImage(product.permission.permission)"
                                loading="lazy"
                                alt="{{ product.permission.permission_name | translate }}"
                                class="ph-card__img"
                            />
                        </div>

                        <h3 class="ph-card__name">{{ product.permission.permission_name | translate }}</h3>
                        <p class="ph-card__tagline">{{ product.permission.permission_description | translate }}</p>

                        <div class="ph-card__price-block">
                            @if (!annualMode) {
                                <div class="ph-card__price-row">
                                    <span class="ph-card__amount">{{ product.amount }}</span>
                                    <span class="ph-card__price-meta">$<br /><small>/mo</small></span>
                                </div>
                            }
                            @if (annualMode) {
                                <div class="ph-card__price-row">
                                    <span class="ph-card__amount">{{ product.amount / 12 | number: '1.1-2' }}</span>
                                    <span class="ph-card__price-meta">$<br /><small>/mo</small></span>
                                </div>
                                <div class="ph-card__billed-annual">
                                    billed {{ product.amount | number: '1.1-2' }} $ / year
                                </div>
                            }
                            <!-- <div class="ph-card__discount-row">
                                <span class="ph-card__strike">{{ product.amount * 2 }} $</span>
                                <span class="ph-card__off-badge">50% OFF</span>
                            </div> -->
                        </div>

                        <div
                            class="ph-card__features"
                            [innerHTML]="product.permission.permission_description + '_2' | translate | markdown"
                        ></div>
                    </div>

                    <div class="ph-card__footer">
                        @if (expired(product.permission.id) || isValid(product.permission.id)) {
                            <div class="ph-card__validity">
                                <svg
                                    width="13"
                                    height="13"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <rect x="3" y="4" width="18" height="18" rx="2" />
                                    <line x1="16" y1="2" x2="16" y2="6" />
                                    <line x1="8" y1="2" x2="8" y2="6" />
                                    <line x1="3" y1="10" x2="21" y2="10" />
                                </svg>
                                {{ 'web.valid_to' | translate }}
                                {{ validity(product.permission.id) | livDate: 'dateShort' }}
                            </div>
                        }

                        @if (demo) {
                            <button
                                class="ph-btn"
                                [class.ph-btn--featured]="isAll(product.permission.permission)"
                                (click)="signIn()"
                            >
                                <svg
                                    width="15"
                                    height="15"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    stroke-width="2"
                                >
                                    <circle cx="9" cy="21" r="1" />
                                    <circle cx="20" cy="21" r="1" />
                                    <path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.61L23 6H6" />
                                </svg>
                                {{ 'web.first_subscription' | translate }}
                            </button>
                        }

                        @if (!demo) {
                            @if (!hasPermission(product.permission.id)) {
                                <button
                                    class="ph-btn"
                                    [class.ph-btn--featured]="isAll(product.permission.permission)"
                                    (click)="checkout(product.id, product)"
                                >
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <circle cx="9" cy="21" r="1" />
                                        <circle cx="20" cy="21" r="1" />
                                        <path d="M1 1h4l2.68 13.39a2 2 0 001.99 1.61h9.72a2 2 0 001.99-1.61L23 6H6" />
                                    </svg>
                                    {{ 'web.first_subscription' | translate }}
                                </button>
                            }
                            @if (expired(product.permission.id)) {
                                <button class="ph-btn ph-btn--renew" (click)="checkout(product.id, product)">
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <polyline points="23 4 23 10 17 10" />
                                        <path d="M20.49 15a9 9 0 11-2.12-9.36L23 10" />
                                    </svg>
                                    {{ 'web.renew_subscription' | translate }}
                                </button>
                            }
                            @if (isValid(product.permission.id)) {
                                <button class="ph-btn ph-btn--active" disabled>
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        stroke-width="2"
                                    >
                                        <polyline points="20 6 9 17 4 12" />
                                    </svg>
                                    {{ 'web.active_subscription' | translate }}
                                    @if (isTrial(product.permission.id)) {
                                        <span class="payment-trial">Trial</span>
                                    }
                                </button>
                            }
                        }
                    </div>
                </div>
            }
        </div>
    </section>

    <!-- ═══════════════════════════ EXPIRED TRIAL MODAL ═══════════════════════════ -->
    @if (isExpiredTrial()) {
        <div id="myModal" class="payment-modal" (click)="closeModal()">
            <div class="payment-modal-content">
                <span class="close" (click)="closeModal()">&times;</span>
                <div class="text-center">
                    <h2 class="p-3 emph-text-node payment-modal-h2">{{ 'web.trial_period_expired' | translate }}</h2>
                    <div>
                        <img src="/img/OK.png" alt="" style="max-width: 40%" class="img-fluid img-cover" />
                    </div>
                    <p class="p-3 mt-3">{{ 'web.trial_period_expired_text' | translate }}</p>
                </div>
            </div>
        </div>
    }
</div>
